import React, { useState, useEffect } from 'react';
import './VoiceGames.css';
import SimonSays from './SimonSays';
import GuessTheNumber from './GuessTheNumber';
import ColorPicker from './ColorPicker';
import MathQuiz from './MathQuiz';
import WordReversal from './WordReversal';

const VoiceGames = () => {
  const [currentGame, setCurrentGame] = useState(null);

  const games = {
    "JM Says": <SimonSays />,
    "Guess the Number": <GuessTheNumber />,
    // "Color Picker": <ColorPicker />,
    // "Math Quiz": <MathQuiz />,
    "Word Reversal": <WordReversal />
  };

  return (
    <div className="AppVG">
      <h1>Voice-Activated Games</h1>
      <div className="game-selector">
        {Object.keys(games).map(game => (
          <button key={game} onClick={() => setCurrentGame(games[game])}>
            {game}
          </button>
        ))}
      </div>
      <div className="game-container">
        {currentGame}
      </div>
    </div>
  );
};

export default VoiceGames;

